<template>
  <echarts :options="options" class="chart-stage"></echarts>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  components: {
    echarts
  },
  props: {
    category: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    grid: {
      type: Object,
      default() {
        return {}
      }
    },
    unit: {
      type: String,
      default: ''
    },
    unitX: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // ====================================
      // 深true|浅false
      tmpModeFlag : (String(localStorage.getItem("modeFlag")) == "true" ? true : false),
      // tmpThemeColorFlag : (localStorage.getItem("themeColorFlag") || "mt-blue"),
      // ====================================
      // 注：legend(线)使用rgba会出现悬浮时图例消失的情况
      // 此处不支持变量！（默认浅色）
      // lineColor: [
      //   // [@teal：深rgba(87, 219, 196, 1)|浅rgba(0, 163, 141, 1)]
      //   'transparent', 
      //   // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
      //   'transparent', 
      //   // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
      //   'transparent',
      // ],
      // 此处不支持变量！（默认浅色）
      areaColor: [
        // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
        'rgba(81, 149, 218, 1)',
        // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
        'rgba(140, 128, 255, 1)', 
        // [@teal：深rgba(87, 219, 196, 1)|浅rgba(0, 163, 141, 1)]
        'rgba(0, 163, 141, 1)', 
      ],
      // 饼图所用颜色定义
      polarColor: [
        // [@yellowlight：深#534600|浅#DFC64C]
        '#DFC64C', 
        // [@pink：深#FFB1CB|浅#FD4A98]
        '#FD4A98', 
        // [@purple：深#F8ACFF|浅#DA54FA]
        '#DA54FA', 
        // [@deepblue：深#C6BFFF|浅#8C80FF]
        '#8C80FF', 
        // [@amberlight：深#614000|浅#FDBA4B]
        '#FDBA4B', 
        // [@limelight：深#394D00|浅#B3D267]
        '#B3D267', 
        // [@purplelight：深#7A0095|浅#F6ADFF]
        '#F6ADFF', 
      ],
      // =======================================
      // 将options中所有与颜色相关（即换肤相关）的，
      // 在data中定义，在watch中重新赋值。
      // .......................................
      // (深#9ACAFF|浅#5195DA)
      // color: this.tmpModeFlag?'#9ACAFF':'#5195DA',
      // ['#9ACAFF', '#FFB2BB',] ['#5195DA', '#FF4F72',]
      // seriesItemStylEmphasisColor: 
      //   String(localStorage.getItem("modeFlag")) == 'true' ? ['#9ACAFF', '#FFB2BB', 'yellow'] : ['#5195DA', '#FF4F72', 'purple'],
      // .............
      // 默认浅色
      // .............
      // seriesItemStylEmphasisColor: ['purple', 'orange'],
      // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
      seriesItemStylEmphasisBorderColor: 'rgba(251, 253, 248, 0.5)',
      tooltipBackgroundColor: 'rgba(251,253,252,0.9)',
      tooltipTextStyleColor: 'rgba(25,28,26,1)',
      legendTextStyleColor: 'rgba(25,28,26,1)',
      legendInactiveColor: '#C0C9C2',
      // [@outline:深#89938C|浅#707973]
      xAxisAxisLineLineStyleColor: '#707973',
      // [@onsurfacevariant：深#C0C9C2|浅#404943]
      xAxisAxisLabelColor: '#404943',
      // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
      xAxisAxisPointerLineStyleColor: 'rgba(0, 136, 96, 0.16)',
      // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
      yAxisSplitLineLineStyleColor: 'rgba(0, 136, 96, 0.08)',
      // [L5：深#000|浅#000（阴影色值相同但参数有异）]
      // 深：0px 14px 28px rgba(0,0,0,48%),
      //    0px 0px 8px rgba(0,0,0,40%);
      // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
      //    0px 12.8px 28.8px rgba(0,0,0,13%);
      tooltipExtraCssText: 'box-shadow: 0px 2.4px 7.4px rgba(0,0,0,11%), 0px 12.8px 28.8px rgba(0,0,0,13%)', 
      // 堆叠面积色块间距
      // [@onprimary:深0,56,36|浅255,255,255]
      seriesLineStyleColor: 'rgba(255,255,255,1)',
      // 柱状悬浮蒙版
      // 暂时：深rgba(255,255,255,0.1)|浅rgba(0,0,0,0.1)
      tooltipaxisPointerShadowStyleColor: 'rgba(0,0,0,0.1)',
      // ======================================= 
      // 所用颜色     
      barColor: [],
      // 原始颜色
      dataColor:[
        {
          name: '参数1',
          // [@pink：深rgba(255, 177, 203, 1)|浅rgba(253, 74, 152, 1)]
          // color:'rgba(253, 74, 152, 1)',
          // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
          color: 'rgba(140, 128, 255, 1)',
        },
        // {
        //   name: '参数2',
        //   color:'rgba(255, 177, 203, 1)'
        // },
        // // 发电量
        // {
        //   // name:this.$t("device.generated"),
        //   name: '发电量',
        //   // [@pink：深rgba(255, 177, 203, 1)|浅rgba(253, 74, 152, 1)]
        //   color:'rgba(253, 74, 152, 1)'
        // },
        // // 买电量
        // {
        //   // name:this.$t("device.bought"),
        //   name: '买电量',
        //   // [@pinklight：深rgba(142, 0, 75, 1)|浅rgba(255, 177, 203, 1)]
        //   color:'rgba(255, 177, 203, 1)'
        // },
        // // 卖电量
        // {
        //   // name:this.$t("device.sold"),
        //   name: '卖电量',
        //   color:'rgb(141, 222, 38)'
        // },
        // // 充电量
        // {
        //   // name:this.$t("device.charged"),
        //   name: '充电量',
        //   color:'rgb(31, 206, 164)'
        // },
        // // 放电量
        // {
        //   // name:this.$t("device.discharged"),
        //   name: '放电量',
        //   color:'rgb(33, 156, 225)'
        // },
        // // 用电量
        // {
        //   // name:this.$t("device.used"),
        //   name: '用电量',
        //   color:'rgb(255, 108, 26)'
        // },
      ],
      arrTmp: [],
    }
  },
  created() {
    // [创建vue实例时]获取当前模式与主题下的图表颜色系列
    this.getEchartsColor();
    // =============================================
    // var array = []
    // this.data.forEach(element => {
    //   this.dataColor.forEach(elementItem => {
    //     // 每项有每项的颜色
    //     if(element.name==elementItem.name){
    //       array.push(elementItem.color);
    //     }
    //   });
    // });
    // this.barColor = array;
    // ============================================
    // this.arrTmp = [];
    // this.data.forEach(element => {
    //   this.dataColor.forEach(elementItem => {
    //     // 每项有每项的颜色
    //     if(element.name==elementItem.name){
    //       this.arrTmp.push(elementItem.color);
    //     }
    //   });
    // });
    // this.barColor = this.arrTmp;
    // ============================================
  },
  computed: {
    options() {
      // let series = [], legends = [];
      // this.data.forEach(ele => {
      //   legends.push(ele.name)
      //   series.push({
      //     type: 'bar',
      //     name: ele.name,
      //     data: ele.value,
      //   })
      // });

      let color = "red";
      let data = [
          {name: '图例A', value: 40},
          {name: '图例B', value: 50},
          {name: '图例C', value: 60},
          {name: '图例D', value: 80},
          // {name: '图例E', value: 150},
      ];
      let category = ['图例A', '图例B', '图例C', '图例D'];
      let grid = {
        ...{
          top: "45",
          left: "60",
          right: "30",
          // ===
          bottom: "70"
        }, ...this.grid
      };
      return {
        grid,
        toolbox: {
          show: false,
        },
        // backgroundColor: "#fff",
        // 角度==========
        angleAxis: {
          // show: true,
          axisLine: {
            // 外环线
            lineStyle: {
              color: this.yAxisSplitLineLineStyleColor,
            }
          },
          splitLine: {
            // 放射线
            lineStyle: {
              color: this.yAxisSplitLineLineStyleColor,
            }
          },
          // 外环标签（文字）
          axisLabel: {
            fontSize: 10,
          },
          // 外环刻度
          axisTick: {
            lineStyle: {
              width: 0,
            }
          },        
          min: function(value) {
            return value.min = 0;
          },
          max: function(value) {
            return value.max * 4 / 3;
          }
          },
        // 坐标==========
        radiusAxis: {
          type: 'category',
          data: category,
          z: 10,
          // 内部标签（文字）
          axisLabel: {
            fontSize: 8,
            interval: 0,
          },
          // 内环刻度
          axisTick: {
            lineStyle: {
              width: 1,
              color: this.xAxisAxisLineLineStyleColor,
            },
            // 刻度齿对准值
            alignWithLabel: true,
          },
          // 内环刻度基线（垂直）
          axisLine: {
            lineStyle: {
              width: 1,
              color: this.xAxisAxisLineLineStyleColor,
              // color: this.radiusAxisLineStyleColor,
            }
          }
        },
        // 雷达==========
        polar: [
          {
            // show: 0,
            // center: ['50%', '50%'],
            radius: [25, '78%'],
            center: ['50%', '52%'],
          }
        ],
        legend: {
          show: false,
        },
        // 文字样式
        textStyle:{
          color: this.legendTextStyleColor,
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: this.tooltipBackgroundColor,
          borderColor: "transparent",
          borderWidth: "1",
          textStyle: {
            color: this.tooltipTextStyleColor,
            fontSize: 12,
          },
          axisPointer: {
            // #################################
            // 柱状悬浮显示蒙版，折线图悬浮显示线条
            // #################################
            type: "shadow",
            shadowStyle : {
              color: this.tooltipaxisPointerShadowStyleColor,
            },
          },
          // 阴影
          extraCssText: this.tooltipExtraCssText, 
          // 格式化数据
          formatter: function(params, ticket, callback) {
            // console.log("formatter-params：", params);
            // ..........................................
            let tooltipItems = '';
            for (let index in params) {
              tooltipItems += 
                "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:6px;height:6px;background-color:" + 
                params[index].color+"'></span>" + 
                params[index].axisValueLabel + 
                "：" + 
                params[index].value + 
                '<br>';
            }
            return tooltipItems;
          },
        },
        series: [
          {
            type: 'bar',
            coordinateSystem: 'polar',
            barWidth: 11,
            // name: "值",
            data: data.map((item, index) => {
              return {
                value: item.value,
                name: item.name,
                itemStyle: {
                  color: color[index]
                }
              }
            }),
          },
        ]
      };
    }
  },
  watch: {
    // tmpModeFlag(val){
    //   if(val){
    //     console.log("watch-tmpModeFlag");
    //   }
    // },
    // 响应更新换肤事件
    "$store.state.event.updateSkin4"(val) {
      if (val) {
        // console.log("刷新本页");
        location.reload();
        // ....................................
        // true深色 | false 浅色
        let tmpMode =
          String(localStorage.getItem("modeFlag")) == "true" ? true : false;
        // 各种主题色
        // let tmpThemeColor = localStorage.getItem("themeColorFlag") || "mt-blue";
        // ....................................
        // 一个项目一个主题色，仅做深浅模式切换
        // 深-蓝
        // &&tmpThemeColor=='mt-blue'
        if(tmpMode){
          this.lineColor = [
            // @blue80=>#9ACAFF
            // @rose80=>#FFB2BB
            '#9ACAFF', '#FFB2BB',
            // '#dade27','#8dde26',
            // '#1fcea4', '#219ce1'
          ];
          this.dataColor = [
            // 发电量
            {
              // name:this.$t("device.generated"),
              name: '参数1',
              // [@pink：深rgba(255, 177, 203, 1)|浅rgba(253, 74, 152, 1)]
              // color:'rgba(255, 177, 203, 1)',
              // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
              color: 'rgba(198, 191, 255, 1)',
            },
            // 买电量
            // {
            //   // name:this.$t("device.bought"),
            //   name: '参数2',
            //   // [@pinklight：深rgba(142, 0, 75, 1)|浅rgba(255, 177, 203, 1)]
            //   color:'rgba(142, 0, 75, 1)'
            // },
          ];
          this.polarColor = [
            // [@yellowlight：深#534600|浅#DFC64C]
            '#534600',
            // [@pink：深#FFB1CB|浅#FD4A98]
            '#FFB1CB',
            // [@purple：深#F8ACFF|浅#DA54FA]
            '#F8ACFF',  
            // [@deepblue：深#C6BFFF|浅#8C80FF]
            '#C6BFFF', 
            // [@amberlight：深#614000|浅#FDBA4B]
            '#614000', 
            // [@limelight：深#394D00|浅#B3D267]
            '#394D00', 
            // [@purplelight：深#7A0095|浅#F6ADFF]
            '#7A0095', 
          ];
          // ****************
          // ============================================
          this.arrTmp = [];
          this.data.forEach(element => {
            this.dataColor.forEach(elementItem => {
              // 每项有每项的颜色
              if(element.name==elementItem.name){
                this.arrTmp.push(elementItem.color);
              }
            });
          });
          this.barColor = this.arrTmp;
          // ============================================
          // (深#9ACAFF|浅#5195DA)
          // this.seriesItemStylEmphasisColor = ['#9ACAFF', '#FFB2BB', 'yellow'];
          // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
          this.seriesItemStylEmphasisBorderColor = '(25, 28, 26, 0.5)';
          // #191C1A
          this.tooltipBackgroundColor = 'rgba(25,28,26,0.9)';
          // #FBFDFC
          this.tooltipTextStyleColor = 'rgba(251,253,252,0.9)';
          // #FBFDFC
          this.legendTextStyleColor = 'rgba(251,253,252,0.9)';
          // #707973
          this.legendInactiveColor = '#707973';
          // [@outline:深#89938C|浅#707973]
          this.xAxisAxisLineLineStyleColor = '#89938C';
          // [@onsurfacevariant：深#C0C9C2|浅#404943]
          this.xAxisAxisLabelColor = '#C0C9C2';
          // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
          this.xAxisAxisPointerLineStyleColor = 'rgba(108, 219, 172, 0.16)';
          // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
          this.yAxisSplitLineLineStyleColor = 'rgba(108, 219, 172, 0.08)';
          // [L5：深#000|浅#000（阴影色值相同但参数有异）]
          // 深：0px 14px 28px rgba(0,0,0,48%),
          //    0px 0px 8px rgba(0,0,0,40%);
          // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
          //    0px 12.8px 28.8px rgba(0,0,0,13%);
          this.tooltipExtraCssText = 'box-shadow: 0px 14px 28px rgba(0,0,0,48%), 0px 0px 8px rgba(0,0,0,40%)';
          // 暂时：深rgba(255,255,255,0.1)|浅rgba(0,0,0,0.1)
          this.tooltipaxisPointerShadowStyleColor = 'rgba(255,255,255,0.1)';
          // ****************
        }
        // 浅-蓝
        // &&tmpThemeColor=='mt-blue'
        if(!tmpMode){
          this.lineColor = [
            // @blue60=>#5195DA
            // @rose60=>#FF4F72
            '#5195DA', '#FF4F72',
            // '#dade27','#8dde26',
            // '#1fcea4', '#219ce1'
          ];
          this.dataColor = [
            // 发电量
            {
              // name:this.$t("device.generated"),
              name: '参数1',
              // [@pink：深rgba(255, 177, 203, 1)|浅rgba(253, 74, 152, 1)]
              // color:'rgba(253, 74, 152, 1)',
              // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
              color: 'rgba(140, 128, 255, 1)',
            },
            // 买电量
            // {
            //   // name:this.$t("device.bought"),
            //   name: '参数2',
            //   // [@pinklight：深rgba(142, 0, 75, 1)|浅rgba(255, 177, 203, 1)]
            //   color:'rgba(255, 177, 203, 1)'
            // },
          ];
          this.polarColor = [
            // [@yellowlight：深#534600|浅#DFC64C]
            '#DFC64C',
            // [@pink：深#FFB1CB|浅#FD4A98]
            '#FD4A98', 
            // [@purple：深#F8ACFF|浅#DA54FA]
            '#DA54FA', 
            // [@deepblue：深#C6BFFF|浅#8C80FF]
            '#8C80FF', 
            // [@amberlight：深#614000|浅#FDBA4B]
            '#FDBA4B', 
            // [@limelight：深#394D00|浅#B3D267]
            '#B3D267', 
            // [@purplelight：深#7A0095|浅#F6ADFF]
            '#F6ADFF', 
          ];
          // ****************
          // ============================================
          this.arrTmp = [];
          this.data.forEach(element => {
            this.dataColor.forEach(elementItem => {
              // 每项有每项的颜色
              if(element.name==elementItem.name){
                this.arrTmp.push(elementItem.color);
              }
            });
          });
          this.barColor = this.arrTmp;
          // ============================================
          // (深#9ACAFF|浅#5195DA)
          // this.seriesItemStylEmphasisColor = ['#5195DA', '#FF4F72', 'purple'];
          // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
          this.seriesItemStylEmphasisBorderColor = 'rgba(251, 253, 248, 0.5)';
          // #FBFDFC
          this.tooltipBackgroundColor = 'rgba(251,253,252,0.9)';
          // #191C1A
          this.tooltipTextStyleColor = 'rgba(25,28,26,0.9)';
          // #191C1A
          this.legendTextStyleColor = 'rgba(25,28,26,0.9)';
          // #C0C9C2
          this.legendInactiveColor = '#C0C9C2';
          // [@outline:深#89938C|浅#707973]
          this.xAxisAxisLineLineStyleColor = '#707973';
          // [@onsurfacevariant：深#C0C9C2|浅#404943]
          this.xAxisAxisLabelColor = '#404943';
          // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
          this.xAxisAxisPointerLineStyleColor = 'rgba(0, 136, 96, 0.16)';
          // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
          this.yAxisSplitLineLineStyleColor = 'rgba(0, 136, 96, 0.08)';
          // [L5：深#000|浅#000（阴影色值相同但参数有异）]
          // 深：0px 14px 28px rgba(0,0,0,48%),
          //    0px 0px 8px rgba(0,0,0,40%);
          // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
          //    0px 12.8px 28.8px rgba(0,0,0,13%);
          this.tooltipExtraCssText = 'box-shadow: 0px 2.4px 7.4px rgba(0,0,0,11%), 0px 12.8px 28.8px rgba(0,0,0,13%)';
          // 暂时：深rgba(255,255,255,0.1)|浅rgba(0,0,0,0.1)
          this.tooltipaxisPointerShadowStyleColor = 'rgba(0,0,0,0.1)';
          // ****************
        }
        // ....................................
        // 重置该事件状态
        this.$store.state.event.updateSkin4 = false;
      }
    },
  },
  methods: {
    // [创建vue实例时]获取当前模式与主题下的图表颜色系列
    getEchartsColor(){
      // ....................................
      // true深色 | false 浅色
      let tmpMode =
        String(localStorage.getItem("modeFlag")) == "true" ? true : false;
      // 各种主题色
      // let tmpThemeColor = localStorage.getItem("themeColorFlag") || "mt-blue";
      // ....................................
      // 一个项目一个主题色，仅做深浅模式切换
      // 深-蓝
      // &&tmpThemeColor=='mt-blue'
      if(tmpMode){
        // this.lineColor = [
        //   // [@teal：深rgba(87, 219, 196, 1)|浅rgba(0, 163, 141, 1)]
        //   'transparent', 
        //   // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
        //   'transparent', 
        //   // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
        //   'transparent',
        // ];
        this.areaColor = [
          // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
          'rgba(154, 202, 255, 1)',
          // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
          'rgba(198, 191, 255, 1)', 
          // [@teal：深rgba(87, 219, 196, 1)|浅rgba(0, 163, 141, 1)]
          'rgba(87, 219, 196, 1)', 
        ];
        this.dataColor = [
          // 发电量
          {
            // name:this.$t("device.generated"),
            name: '参数1',
            // [@pink：深rgba(255, 177, 203, 1)|浅rgba(253, 74, 152, 1)]
            // color:'rgba(255, 177, 203, 1)',
            // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
            color: 'rgba(198, 191, 255, 1)',
          },
          // 买电量
          // {
          //   // name:this.$t("device.bought"),
          //   name: '参数2',
          //   // [@pinklight：深rgba(142, 0, 75, 1)|浅rgba(255, 177, 203, 1)]
          //   color:'rgba(142, 0, 75, 1)'
          // },
        ];
        this.polarColor = [
          // [@yellowlight：深#534600|浅#DFC64C]
          '#534600',
          // [@pink：深#FFB1CB|浅#FD4A98]
          '#FFB1CB', 
          // [@purple：深#F8ACFF|浅#DA54FA]
          '#F8ACFF', 
          // [@deepblue：深#C6BFFF|浅#8C80FF]
          '#C6BFFF', 
          // [@amberlight：深#614000|浅#FDBA4B]
          '#614000', 
          // [@limelight：深#394D00|浅#B3D267]
          '#394D00', 
          // [@purplelight：深#7A0095|浅#F6ADFF]
          '#7A0095', 
        ];
        // ****************
        // ============================================
        this.arrTmp = [];
        this.data.forEach(element => {
          this.dataColor.forEach(elementItem => {
            // 每项有每项的颜色
            if(element.name==elementItem.name){
              this.arrTmp.push(elementItem.color);
            }
          });
        });
        this.barColor = this.arrTmp;
        // ============================================
        // (深#9ACAFF|浅#5195DA)
        this.seriesItemStylEmphasisColor = ['#9ACAFF', '#FFB2BB', 'yellow'];
        // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
        this.seriesItemStylEmphasisBorderColor = 'rgba(25, 28, 26, 0.5)';
        // #191C1A
        this.tooltipBackgroundColor = 'rgba(25,28,26,0.9)';
        // #FBFDFC
        this.tooltipTextStyleColor = 'rgba(251,253,252,1)';
        // #FBFDFC
        this.legendTextStyleColor = 'rgba(251,253,252,1)';
        // #707973
        this.legendInactiveColor = '#707973';
        // [@outline:深#89938C|浅#707973]
        this.xAxisAxisLineLineStyleColor = '#89938C';
        // [@onsurfacevariant：深#C0C9C2|浅#404943]
        this.xAxisAxisLabelColor = '#C0C9C2';
        // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
        this.xAxisAxisPointerLineStyleColor = 'rgba(108, 219, 172, 0.16)';
        // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
        this.yAxisSplitLineLineStyleColor = 'rgba(108, 219, 172, 0.08)';
        // [L5：深#000|浅#000（阴影色值相同但参数有异）]
        // 深：0px 14px 28px rgba(0,0,0,48%),
        //    0px 0px 8px rgba(0,0,0,40%);
        // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
        //    0px 12.8px 28.8px rgba(0,0,0,13%);
        this.tooltipExtraCssText = 'box-shadow: 0px 14px 28px rgba(0,0,0,48%), 0px 0px 8px rgba(0,0,0,40%)';
        // [@onprimary:深0,56,36|浅255,255,255]
        this.seriesLineStyleColor = 'rgba(0,56,36,1)';
        // 暂时：深rgba(255,255,255,0.1)|浅rgba(0,0,0,0.1)
        this.tooltipaxisPointerShadowStyleColor = 'rgba(255,255,255,0.1)';
        // ****************
      }
      // 浅-蓝
      // &&tmpThemeColor=='mt-blue'
      if(!tmpMode){
        // this.lineColor = [
        //   // [@teal：深rgba(87, 219, 196, 1)|浅rgba(0, 163, 141, 1)]
        //   'transparent', 
        //   // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
        //   'transparent', 
        //   // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
        //   'transparent',
        // ];
        this.areaColor = [
          // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
          'rgba(81, 149, 218, 1)',
          // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
          'rgba(140, 128, 255, 1)', 
          // [@teal：深rgba(87, 219, 196, 1)|浅rgba(0, 163, 141, 1)]
          'rgba(0, 163, 141, 1)', 
        ];
        this.dataColor = [
          // 发电量
          {
            // name:this.$t("device.generated"),
            name: '参数1',
            // [@pink：深rgba(255, 177, 203, 1)|浅rgba(253, 74, 152, 1)]
            // color:'rgba(253, 74, 152, 1)',
            // [@deepblue：深rgba(198, 191, 255, 1)|浅rgba(140, 128, 255, 1)]
            color: 'rgba(140, 128, 255, 1)',
          },
          // 买电量
          // {
          //   // name:this.$t("device.bought"),
          //   name: '参数2',
          //   // [@pinklight：深rgba(142, 0, 75, 1)|浅rgba(255, 177, 203, 1)]
          //   color:'rgba(255, 177, 203, 1)'
          // },
        ];
        this.polarColor = [
          // [@yellowlight：深#534600|浅#DFC64C]
          '#DFC64C',
          // [@pink：深#FFB1CB|浅#FD4A98]
          '#FD4A98', 
          // [@purple：深#F8ACFF|浅#DA54FA]
          '#DA54FA', 
          // [@deepblue：深#C6BFFF|浅#8C80FF]
          '#8C80FF', 
          // [@amberlight：深#614000|浅#FDBA4B]
          '#FDBA4B', 
          // [@limelight：深#394D00|浅#B3D267]
          '#B3D267', 
          // [@purplelight：深#7A0095|浅#F6ADFF]
          '#F6ADFF', 
        ];
        // ****************
        // ============================================
        this.arrTmp = [];
        this.data.forEach(element => {
          this.dataColor.forEach(elementItem => {
            // 每项有每项的颜色
            if(element.name==elementItem.name){
              this.arrTmp.push(elementItem.color);
            }
          });
        });
        this.barColor = this.arrTmp;
        // ============================================
        // (深#9ACAFF|浅#5195DA)
        this.seriesItemStylEmphasisColor = ['#5195DA', '#FF4F72', 'purple'];
        // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
        this.seriesItemStylEmphasisBorderColor = 'rgba(251, 253, 248, 0.5)';
        // #FBFDFC
        this.tooltipBackgroundColor = 'rgba(251,253,252,0.9)';
        // #191C1A
        this.tooltipTextStyleColor = 'rgba(25,28,26,1)';
        // #191C1A
        this.legendTextStyleColor = 'rgba(25,28,26,1)';
        // #C0C9C2
        this.legendInactiveColor = '#C0C9C2';
        // [@outline:深#89938C|浅#707973]
        this.xAxisAxisLineLineStyleColor = '#707973';
        // [@onsurfacevariant：深#C0C9C2|浅#404943]
        this.xAxisAxisLabelColor = '#404943';
        // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
        this.xAxisAxisPointerLineStyleColor = 'rgba(0, 136, 96, 0.16)';
        // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
        this.yAxisSplitLineLineStyleColor = 'rgba(0, 136, 96, 0.08)';
        // [L5：深#000|浅#000（阴影色值相同但参数有异）]
        // 深：0px 14px 28px rgba(0,0,0,48%),
        //    0px 0px 8px rgba(0,0,0,40%);
        // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
        //    0px 12.8px 28.8px rgba(0,0,0,13%);
        this.tooltipExtraCssText = 'box-shadow: 0px 2.4px 7.4px rgba(0,0,0,11%), 0px 12.8px 28.8px rgba(0,0,0,13%)';
        // [@onprimary:深0,56,36|浅255,255,255]
        this.seriesLineStyleColor = 'rgba(255,255,255,1)';
        // 暂时：深rgba(255,255,255,0.1)|浅rgba(0,0,0,0.1)
        this.tooltipaxisPointerShadowStyleColor = 'rgba(0,0,0,0.1)';
        // ****************
      }
      // ....................................
    }
  },
};
</script>
<style lang="less" scoped>
.chart-stage {
  width: 100%;
  height: 500px;
}
</style>


